import { gql } from 'graphql-request'

export const siteCustomPropertiesQuery = gql`
  query SiteCustomProperties($siteId: ID!) {
    siteCustomProperties(siteId: $siteId) {
      siteId
      name
    }
  }
`

export const sitesCoreUserInstructorsQuery = gql`
  query SitesCoreUserInstructors($siteIds: [ID!]!) {
    sitesCoreUserInstructors(siteIds: $siteIds) {
      firstName
      lastName
      v1Id
      email
      status
    }
  }
`

export const sitesQuery = gql`
  query Sites {
    sites {
      siteId
      name
      status
      createdAt
    }
  }
`

export const sitesPaginatedQuery = gql`
  query SitesPaginated(
    $search: String
    $pageSize: Float
    $cursor: String
    $orderBy: [SitesOrderByInput!]
    $filter: SitesFilterInput
  ) {
    sites(
      search: $search
      pageSize: $pageSize
      cursor: $cursor
      orderBy: $orderBy
      filter: $filter
    ) {
      results {
        cursor
        row {
          siteId
          name
          isV2Enabled
          settings {
            customization {
              colors {
                id
                color
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        totalRecords
      }
    }
  }
`
export const availableSitesQuery = gql`
  query AvailableToAssignSites(
    $filter: FindAvailableToAssignSitesFilters
    $paginate: PaginationInput
    $sort: FindSitesSortOptions
    $search: String
  ) {
    availableToAssignSites(filter: $filter, paginate: $paginate, sort: $sort, search: $search) {
      results {
        node {
          siteId
          name
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        totalRecords
      }
    }
  }
`

export const siteById = gql`
  query Site($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      name
      timezone
      phone
      businessEmail
      addressStreet
      addressStreet2
      addressCity
      addressState
      addressPostalCode
      addressCountry
      logoImage(input: { type: thumbnail, format: webp }) {
        url
      }
      businessHours {
        hasCustomHours
        startTime
        endTime
        customHours {
          monday {
            startTime
            endTime
          }
          tuesday {
            startTime
            endTime
          }
          wednesday {
            startTime
            endTime
          }
          thursday {
            startTime
            endTime
          }
          friday {
            startTime
            endTime
          }
          saturday {
            startTime
            endTime
          }
          sunday {
            startTime
            endTime
          }
        }
      }
      displayBusinessHours
      settings {
        location {
          businessInformation {
            name
            description
            phone
            address {
              city
              state
              country
              postalCode
              street
            }
          }
          socialMedia {
            website
            instagram
            facebook
            x
          }
          configurations {
            numberFormat
            dateFormat
            timeFormat
            currency
            timezone
            dashboardRevenuePeriod
          }
          checkIn {
            enableGeneralCheckIn
            barcodeCheckInScreenRefreshPeriodInSeconds
            enableMobileClientCheckIn
            enableCheckInPopups
            enableCheckInWidget
            enableCheckInSoundAlerts
            checkInStartTime
            checkInEndTime
            allowRecheckinsDuringWindow
            maxRecheckins
            minTimeBetweenRecheckInsInMinutes
            contactlessCheckIn {
              enabled
              enableQRCodeDeeplink
              enableForm
              skipCheckInQuestions
              enableDoorAccess
              formQuestions {
                id
                question
                type
                order
                favorite
                allowCheckInIfBelowOrEqualTo
                options {
                  id
                  text
                  allowCheckIn
                  order
                }
              }
              policyIds
              policies {
                sitePolicyId
                order
                enabled
              }
            }
          }
          communications {
            emailDefaultFromName
            emailDefaultFrom
            smsDefaultFromName
            blackoutTime {
              startTime
              endTime
            }
            customShortCodes {
              iOSAppDownload
              androidAppDownload
              iOSApp
              androidApp
              classes
              workshops
              packages
              dashboard
            }
          }
          tools {
            barcodeCheckIn {
              customUrl
              isActive
              url
            }
            frontDeskKiosk {
              betaVersionEnabled
              customUrl
              enabledModules {
                introOffers
                packages
                checkIn
                classCheckIn
                account
                forms
              }
              isActive
              url
            }
          }
          operations {
            autoLogout
            autoLogoutMinutes
            enableClientsToSignUp
            businessSignUpFields {
              primaryProfile {
                firstName {
                  enabled
                  required
                }
                lastName {
                  enabled
                  required
                }
                email {
                  enabled
                  required
                }
                phone {
                  enabled
                  required
                }
                gender {
                  enabled
                  required
                }
                birthday {
                  enabled
                  required
                }
                barcode {
                  enabled
                  required
                }
                address {
                  enabled
                  required
                }
                zipCode {
                  enabled
                  required
                }
                howDidYouHeadAboutUs {
                  enabled
                  required
                }
                occupation {
                  enabled
                  required
                }
                password {
                  enabled
                  required
                }
                confirmPassword {
                  enabled
                  required
                }
              }
              emergencyContact {
                emergencyContactName {
                  enabled
                  required
                }
                emergencyContactPhone {
                  enabled
                  required
                }
                emergencyContactEmail {
                  enabled
                  required
                }
                emergencyContactAddress {
                  enabled
                  required
                }
                emergencyContactRelation {
                  enabled
                  required
                }
              }
              customProperties {
                customPropertyId
                enabled
                required
              }
              formIds
            }
            clientSignUpFields {
              primaryProfile {
                firstName {
                  enabled
                  required
                }
                lastName {
                  enabled
                  required
                }
                email {
                  enabled
                  required
                }
                phone {
                  enabled
                  required
                }
                gender {
                  enabled
                  required
                }
                birthday {
                  enabled
                  required
                }
                barcode {
                  enabled
                  required
                }
                address {
                  enabled
                  required
                }
                zipCode {
                  enabled
                  required
                }
                howDidYouHeadAboutUs {
                  enabled
                  required
                }
                occupation {
                  enabled
                  required
                }
                password {
                  enabled
                  required
                }
                confirmPassword {
                  enabled
                  required
                }
              }
              emergencyContact {
                emergencyContactName {
                  enabled
                  required
                }
                emergencyContactPhone {
                  enabled
                  required
                }
                emergencyContactEmail {
                  enabled
                  required
                }
                emergencyContactAddress {
                  enabled
                  required
                }
                emergencyContactRelation {
                  enabled
                  required
                }
              }
              customProperties {
                customPropertyId
                enabled
                required
              }
              formIds
              policyIds
            }
            cancellationReasons {
              id
              reason
              enabled
              createdAt
              updatedAt
            }
            suspensionReasons {
              id
              reason
              enabled
              createdAt
              updatedAt
            }
            systemPreferences {
              tabsDisplayed {
                classes
                packages
                requestBooking
                workshops
              }
              defaultBusinessProfileTab
              availableClientsTabs {
                information
                assessment
                notes
                schedule
                payment
              }
              defaultClientTab
              showBusinessInfo
            }
          }
        }
        scheduler {
          rules {
            bookings {
              autoConfirmRequests
              autoDeductCredits
              bookingNotifications
              enableBookABuddy
              enableBookingRequests
              enforceFixedBookingSlotIntervals {
                duration
              }
              requestTimeSlots {
                duration
              }
            }
            cancellations {
              allowClientDeclineAndCancelSessions
              policies {
                classes {
                  days
                  hours
                  minutes
                }
                privates {
                  days
                  hours
                  minutes
                }
                workshops {
                  days
                  hours
                  minutes
                }
              }
            }
            classes {
              daysInAdvance
              defaultColor
              displayClassSize
              displayCompletedClasses
              displayPriceColumn
              instructorTypeFilter
              roomTypeFilter
              sessionTypeFilter
              soapNotes
            }
            privates {
              daysInAdvance
            }
            workshops {
              daysInAdvance
            }
            reservations {
              daysInAdvance {
                releaseType
                rolling {
                  classesBookedUpTo
                  periodOfTime
                  upTo
                  time
                }
                timed {
                  dayOfWeek
                  time
                  numberOfWeeks
                  hoursAfter
                }
              }
              multipleReservations
            }
            waitlist {
              autoConfirmClients
              lockPeriod {
                periodOfTime
                value
              }
              manualMovements
              promotion {
                periodOfTime
                value
              }
              restrictions {
                type
              }
              strategy
              topNBatchSize
              firstToClaim {
                enabled
                windowHours
              }
            }
          }
          calendar {
            defaultView
            showCapacity
            showInstructorNames
          }
          calendarConfigurations {
            enableContinuousEvents
            enableDragAndDrop
            hideTeamMemberFromTeamView
            hideRoomFromRoomView
            calendarStartDay
            calendarInterval
            calendarMinTime
            calendarMaxTime
            defaultBookedListOrder
            defaultCalendarView
          }
          sessionTypes {
            id
            name
            type
            settings
          }
        }
        account {
          billing {
            enabled
            retryFailedPayments {
              enabled
              intervalInDays
              maxAttempts
            }
            transactionFeePreference
          }
          tax {
            enabled
          }
          invoice {
            label
            email
          }
          pointOfSale {
            enableCashDrawer
            itemTypes
          }
          payroll {
            additionalTypes
          }
        }
        retail {
          giftcards {
            enableSharedSites
          }
          fees {
            noShow {
              enabled
              price
              taxSettings
            }
            dishonor {
              enabled
              onAllAttempts
              onFirstAttempt
              onSecondAttempt
              onThirdAttempt
              onDelinquentDays {
                amount
                days
              }
              taxSettings
            }
            destination {
              enabled
              price
              taxSettings
            }
            lateCancel {
              enabled
              price
              taxSettings
            }
          }
          sales {
            miniumSignUpAge
            printPosReceipt
            requireRecipientForGiftCardSales
          }
          additionalBillingTypes {
            enabled
            types {
              id
              type
              name
              enabled
              createdAt
              updatedAt
            }
          }
          general {
            credits {
              referrals {
                creditsExistingClient
                creditsToNewClient
              }
              enableCreditsOnHoldIfClientHasProcessingPayment
              enableCreditsOnHoldIfClientHadFailedPayment
            }
            sales {
              additionalSortOfPackages {
                field
                direction
              }
              enableRestrictedPackages
              autoRenewExhaustedSessionPackages
              defaultAutoRenewToggleEnabledAtSale
              autoAssignClientBarcodeNumber
              allowChangeOfProcessedByAtSale
              allowMembershipSalesWithDuplicateCreditOrSessionTypes
              allowSessionPackageSalesWithDuplicateCreditOrSessionTypes
              redirectAfterPackagePayment
            }
          }
        }
        customization {
          colors {
            id
            color
          }
        }
        updatedAt
      }
      integrations {
        classPass {
          enabled
        }
      }
    }
  }
`

export const siteEnableAddOnsQuery = gql`
  query SiteEnableAddOns($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      adminConfigurations {
        enableAddOns
      }
    }
  }
`

export const siteEnableMembershipPlanChangeQuery = gql`
  query SiteEnableMembershipPlanChange($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      adminConfigurations {
        enableMembershipPlanChange
      }
    }
  }
`

export const siteEnableSharedSitesQuery = gql`
  query SiteEnableSharedSites($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      adminConfigurations {
        enableSharedSites
      }
    }
  }
`

export const siteConnectedSharedSiteIdsQuery = gql`
  query SiteConnectedSharedSiteIds($siteId: ID!) {
    site(siteId: $siteId) {
      siteId
      connectedSharedSiteIds
    }
  }
`
